<template>
  <div class="paybox_t">
    <div class="paybox_top" >
      <div class="title">
        <!-- <img src="../Home/img/微信支付.png" alt=""> -->
        <span>江南药镇收银台</span>
      </div>
      <div class="detail">
        <div class="left">
          <span>订单编号：{{ OrderNo }}</span>
          <span>订单类型：农产品</span>
          <span v-if="device === 'mobile'">应付金额：<em>￥</em><em>{{ OrderPic }}</em></span>
        </div>
        <div class="right" v-if="device !== 'mobile'">
          <span>应付金额：<em>￥</em><em>{{ OrderPic }}</em></span>
        </div>
      </div>
      <div class="tab-container">
        <div
        class="tab"
        :class="['tab', { active: activeTab === 0 }]"
        @click="changeTab(0)"
        >
        微信支付
        </div>
        <!-- <div
        class="tab"
        :class="['tab', { active: activeTab === 1 }]"
        @click="changeTab(1)"
        >
        储蓄卡
        </div>
        <div
        class="tab"
        :class="['tab', { active: activeTab === 2 }]"
        @click="changeTab(2)"
        >
        信用卡
        </div> -->
        <div
        class="tab"
        :class="['tab', { active: activeTab === 3 }]"
        @click="changeTab(3)"
        >
        第三方
        </div>
      </div>
      <div class="content-container">
        <div v-show="activeTab === 0"  class="content">
          <div class="wePay">
            <img src="../Home/img/WePayLogo.png" alt="">
          </div>
          <div class="erweima">
            <img class="image-top"  :src="imageData" >
            <img class="image-bottom  "  src="../Home/img/说明文字.png">
          </div>
        </div>
        <!-- <div v-show="activeTab === 1">
        </div>
        <div v-show="activeTab === 2">
        </div> -->
        <div v-show="activeTab === 3"  class="content"> 
          <p>开发中.....</p>
        </div>
      </div>
    </div>
   
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
    import { VUE_APP_IMG_URL } from "@/config";
    import { mapGetters ,onBeforeUnmount   } from "vuex";
    export default {
      data() {
        return {
          OrderNo:'',
          OrderPic:0,
          wxJsApiParam:'',
          imageData: null,
          activeTab: 0,
          intervalId:null,
          Timeout:null,
        };
      },
      computed: {
        ...mapGetters(["userInfo", "userId", "device"]),
      },
      watch: {},
      created: function () {
        this.imgUrl = VUE_APP_IMG_URL;
			  if (typeof this.$route.query.OrderNo != "undefined") {
      			this.OrderNo = this.$route.query.OrderNo;
            this.OrderPic=this.$route.query.OrderPic;
      			this.GetwxJsApiParam();
    		}
        // const beforeUnmount = onBeforeUnmount(() => {
        //     clearInterval(this.Timeout);
        //     clearInterval(this.intervalId);
        // });
      },
      beforeUnmount() {
        clearInterval(this.Timeout);
        clearInterval(this.intervalId);
      },
      mounted: function () {},
      
      methods: {
        
        async GetwxJsApiParam(){
          let res = await this.$post("payment_Details", { OrderNo: this.OrderNo, PayMethed: 3 }, { responseType: 'arraybuffer' });
          console.log(res,'GetwxJsApiParam');
          let arrayBuffer = res.data; 
          let uint8Array = new Uint8Array(arrayBuffer);
          let base64String = btoa(String.fromCharCode.apply(null, uint8Array));
          console.log(base64String,'base64String');
          this.imageData= 'data:image/png;base64,' + base64String;
          this.Timeout = setTimeout(() => {
            this.intervalId = setInterval(() => {
              this.OrderState();
            }, 1000);
            setTimeout(() => {
              clearInterval(this.intervalId);
            }, 180000);
          }, 5000);
        },
        async OrderState(){
          var res = await this.$post("getOrder_Detail",{OrderNo:this.OrderNo});
          console.log(res,'res');
          this.state = res.data.ResultData.OrderState;
          if(this.state != 1){
            clearInterval(this.intervalId);
            clearInterval(this.Timeout);
            this.$router.push({
		    			path: '/paysuccess',
		    			query: {
		    				OrderNo: this.OrderNo,
		    			}
		    		})
          }
        },
        changeTab(index) {
          this.activeTab = index;
        },
      },
    };
</script>
<style>
.paybox_top{
  width:60%;
  height: 500px;
  border: 1px solid #9a9a9a ;
  margin: auto;
}
.title{
  font-size: 30px;
  margin: 10px 20px;
}
.detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f2f2f2;
  padding: 20px;
}
.left, .right {
  display: flex;
  flex-direction: column;
}
.left span{
  margin-top: 5px;
}
.right{
  margin-right: 100px;
}
.right em{
  font-size: 20px;
}
.tab-container {
  display: flex;
  margin: 20px 0 0 20px;
}

.tab {
  padding: 10px 20px;
  background-color: #ccc;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  border: 1px solid #9a9a9a;
  color: #000;
  cursor: pointer;
}

.tab.active {
  background-color: #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  z-index: 2;
}
.content-container {
  margin-left: 20px;
}
.content {
  padding: 20px;
  width: 70%;
  background-color: #f0f0f0;
  min-height: 200px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.wePay{
  width: 150px;
  height: 40px;
  float: left;
}
.wePay img{
  width: 100%;
  height: 100%;
}
.erweima {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.erweima .image-top,
.erweima .image-bottom {
  max-width: 133px; 
  margin-top: 10px;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>